module.exports = __webpack_public_path__ + "static/media/about4.6d4b8d77.jpg";